import { Link } from "react-router-dom";
import { Phone, MessageCircle, ArrowRight } from "lucide-react";
import { company, whatsappUrl } from "../data/site";
import Reveal from "./Reveal";

export default function CtaSection({
  title = "Sie möchten unkompliziert Platz schaffen?",
  text = "Beschreiben Sie uns kurz Ihr Anliegen. Sie können auf Wunsch direkt Bilder mitsenden. Wir melden uns persönlich bei Ihnen.",
}) {
  return (
    <section className="relative overflow-hidden bg-brand-black grain">
      <div className="container-page relative z-10 py-20 md:py-28">
        <Reveal className="max-w-3xl">
          <span className="kicker text-yellow">Jetzt anfragen</span>
          <h2 className="mt-4 font-heading text-3xl font-extrabold tracking-tight text-white md:text-5xl">
            {title}
          </h2>
          <p className="mt-5 text-base leading-relaxed text-light-gray/70 md:text-lg">{text}</p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:flex-wrap">
            <Link
              to="/kontakt"
              data-testid="cta-anfragen"
              className="inline-flex items-center justify-center gap-2 rounded-sm bg-yellow px-6 py-3.5 font-heading font-bold text-brand-black transition-colors hover:bg-yellow-dark"
            >
              Unverbindlich anfragen <ArrowRight className="h-4 w-4" />
            </Link>
            <a
              href={company.phoneLink}
              data-testid="cta-anrufen"
              className="inline-flex items-center justify-center gap-2 rounded-sm border border-dark-gray bg-anthracite px-6 py-3.5 font-heading font-bold text-white transition-colors hover:bg-dark-gray"
            >
              <Phone className="h-4 w-4" /> Jetzt anrufen
            </a>
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="cta-whatsapp"
              className="inline-flex items-center justify-center gap-2 rounded-sm border border-dark-gray bg-anthracite px-6 py-3.5 font-heading font-bold text-white transition-colors hover:bg-dark-gray"
            >
              <MessageCircle className="h-4 w-4" /> WhatsApp öffnen
            </a>
          </div>
        </Reveal>
      </div>
      <div className="pointer-events-none absolute -right-24 -top-24 h-96 w-96 rounded-full bg-yellow/10 blur-3xl" />
    </section>
  );
}
